import { byId } from 'utils/common';

import type {
  SavedArrangementCanvas,
  UnavailableArrangementItem,
} from 'domains/saved_arrangements';
import type { RootState } from 'store/wos_store';

// Determines which canvases in a saved arrangement are currently unavailable or discontinued
export function getArrangementAvailability(state: RootState, canvases: SavedArrangementCanvas[]) {
  const unavailability: UnavailableArrangementItem[] = [];
  const discontinued = 'discontinued';
  const unavailable = 'unavailable';

  canvases.forEach((canvas) => {
    const { id, product: productId, options: optionConfig } = canvas.config;
    const product = state.products.entities[productId];

    // Very unlikely that a product would be temporarily unavailable, even less likely
    // that a temporarily unavailable product is able to be in an arrangement
    if (product && product.unavailable) {
      unavailability.push({
        type: 'product',
        reason: unavailable,
        item: { id, name: product.name_long, parentName: 'Size' },
      });
    } else if (!product) {
      unavailability.push({ type: 'product', reason: discontinued, item: { id } });
    }

    // No sense to check the options if product can't be loaded
    if (!product || product.unavailable) return;

    Object.entries(optionConfig).forEach(([optionGroupId, optionId]) => {
      const optionGroup = state.optionGroups.entities[optionGroupId];
      const option = optionGroup?.options.find(byId(optionId));

      // Will never be the case that an option group is temporarily unavailable
      if (!optionGroup) {
        unavailability.push({ type: 'option-group', reason: discontinued, item: { id } });
        return;
      }

      if (option && option.unavailable) {
        unavailability.push({
          type: 'option',
          reason: unavailable,
          item: { id, name: option.name, parentName: optionGroup.name },
        });
      } else if (!option) {
        unavailability.push({ type: 'option', reason: discontinued, item: { id } });
      }
    });
  });

  return unavailability;
}
